import { IApiSessionMetadataUpdated } from 'interfaces/tagging/ApiModels/IApiSessionMetadataUpdated';
import React from 'react';
import ReadOnlySwitch from '../ReadOnlySwitch/ReadOnlySwitch';
import { Content, SmallTitle } from './FeaturesStyles';

interface IProps {
  session?: IApiSessionMetadataUpdated;
}

const Features: React.FC<IProps> = (props) => {
  const { session } = props;

  return (
    <>
      {!session ? null : (
        <Content>
          <SmallTitle>Features</SmallTitle>
          <ReadOnlySwitch label='Player Tracking enabled' checked={session.isPlayerTrackingEnabled} />
          <ReadOnlySwitch label='Video Capture enabled' checked={session.isVideoCaptureEnabled} />
          <ReadOnlySwitch label='Player Positioning enabled' checked={session.isPlayerPositioningEnabled ?? false} />
          <ReadOnlySwitch label='3D Spin enabled' checked={session.is3DSpinEnabled ?? false} />
          <ReadOnlySwitch label='Bat Tracking enabled' checked={session.isBatTrackingEnabled ?? false} />
        </Content>
      )}
    </>
  );
};

export default Features;
